import React from 'react';
import { findDOMNode } from 'react-dom'

class BasicComponent extends React.Component {

    constructor(props) {
        super(props);

        this._bind = this._bind.bind(this);
        this._bind('addClass', 'removeClass');
    }

    _bind(...methods) {
        methods.forEach( (method) => this[method] = this[method].bind(this) );
    }

    addClass(className) {
        const el = findDOMNode(this);
        el.classList.add(className);
    }

    removeClass(className) {
        const el = findDOMNode(this);
        el.classList.remove(className);
    }
}

module.exports = BasicComponent;